import { useTranslations } from '@/contexts/translation/useTranslations';
import useGetAuthentication from '@/domains/authentication/useGetAuthentication';
import EmailPasswordRecoveryForm from '@/pages/authentication/EmailPasswordRecovery/EmailPasswordRecoveryForm/EmailPasswordRecoveryForm.tsx';
import useAuthNavigator from '@/pages/authentication/navigation/useAuthNavigator.ts';
import ThemeTypography from '@/theme/Components/ThemeTypography/ThemeTypography';

interface EmailPasswordRecoveryProps {
  handleContent: () => void;
}

const EmailPasswordRecovery = ({
  handleContent,
}: EmailPasswordRecoveryProps) => {
  useGetAuthentication();
  const { userType } = useAuthNavigator();
  const { t } = useTranslations({ ns: 'auth' });

  return (
    <>
      <ThemeTypography style={{ textAlign: 'center' }} variant="h3">
        {t(`lostpassword.${userType}.title`)}
      </ThemeTypography>
      <ThemeTypography style={{ textAlign: 'center', marginBottom: 24 }}>
        {t(`lostpassword.${userType}.subtitle`)}
      </ThemeTypography>

      <EmailPasswordRecoveryForm handleContent={handleContent} />
    </>
  );
};

export default EmailPasswordRecovery;
